import axios from 'axios'

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_ADMIN_BASE_URL,
  headers: { 'Content-Type': 'application/json' }
})

export default {
  setAccessToken (accessToken) {
    httpClient.defaults.headers = { Authorization: `Bearer ${accessToken}` }
  },
  async getSubscription () {
    try {
      const { data } = await httpClient.get('/subscriptions')
      return data
    } catch (e) {
      console.error(`Can't fetch subscriptions. Error: ${e.message}`)
      throw new Error('Cannot fetch subscriptions from API')
    }
  },
  async createSubscription (name, quota) {
    try {
      const { data } = await httpClient.post('/new-subscription', { name, quota })
      return data
    } catch (e) {
      console.error(`Can't create new subscription. Error: ${e.message}`)
      throw new Error('Cannot create new subscription')
    }
  },
  async updateSubscription (subscriptionId, name, quota) {
    try {
      const { data } = await httpClient.post(`${subscriptionId}/update`, { name, quota })
      return data
    } catch (e) {
      console.error(`Can't update subscription. Error: ${e.message}`)
      throw new Error('Cannot update subscription')
    }
  },
  async deleteSubscription (subscriptionId) {
    try {
      await httpClient.post(`${subscriptionId}/delete`)
    } catch (e) {
      console.error(`Can't delete subscription. Error: ${e.message}`)
      throw new Error('Cannot delete subscription')
    }
  },
  async changeSubscription (subscriptionId) {
    try {
      await httpClient.post(`${subscriptionId}/change`)
    } catch (e) {
      console.error(`Can't change subscription. Error: ${e.message}`)
      throw new Error('Cannot change subscription')
    }
  }
}
